import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Loader } from '@karma/components';
import BackButton from 'components/atoms/BackButton/BackButton';
import { PATHS } from 'consts/paths';
import * as SECTIONS_NAMES from 'consts/sectionsNames';
import DashboardLayout from 'components/templates/DashboardLayout/DashboardLayout';
import { ReferralSourceContext } from 'contexts/ReferralSourceContext';
import BlockCardSales from 'components/organisms/BlockCardSales/BlockCardSales';
import * as newSalesActions from 'store/newSales/actions';
import * as newSalesSelectors from 'store/newSales/selectors';
import { getMarketingCopy } from 'store/retailersGroupsTitles/selectors';
import useAction from 'hooks/useAction';
import { getQueryParam } from 'functions/urlHelpers';
import { QUERY_PARAMS } from 'consts/queryParams';
import { Content, BackButtonContainer } from './NewSalesPage.style';

const NewSalesPage = () => {
  const newSalesLoaded = useSelector(newSalesSelectors.getLoaded);
  const marketingCopy = useSelector(getMarketingCopy);
  const biscotti = getQueryParam(QUERY_PARAMS.biscotti);

  const requestGetNewSales = useAction(newSalesActions.requestGetNewSales);

  useEffect(() => {
    if (!newSalesLoaded) {
      requestGetNewSales({ page: 1, biscotti });
    }
  }, []);

  return (
    <ReferralSourceContext.Provider value="SALES_page">
      <DashboardLayout title="app:headerSales" showFooter={false}>
        <Content>
          <BackButtonContainer>
            <BackButton label={marketingCopy || SECTIONS_NAMES.NEW_SALES} to={PATHS.HOME} />
          </BackButtonContainer>

          {newSalesLoaded ? <BlockCardSales /> : <Loader absolute />}
        </Content>
      </DashboardLayout>
    </ReferralSourceContext.Provider>
  );
};

export default NewSalesPage;
